var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutograph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "autograph 1",
    clipPath: "url(#clip0_1653_4471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.902 10.9419C23.7121 11.6989 23.3062 12.1686 22.8134 12.3103L18.8282 13.4608C19.3264 13.316 19.7269 12.8494 19.9222 12.089C20.3106 10.5588 19.6992 8.42066 18.5631 7.31714C17.9891 6.76164 17.3869 6.57396 16.8887 6.71868L20.8685 5.57148C21.371 5.42762 21.9689 5.61424 22.5429 6.16994C23.6833 7.27456 24.2916 9.40696 23.902 10.9419Z",
    fill: "#4D5772"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.9205 12.0862C19.5359 13.6197 18.2942 13.9641 17.1563 12.8612C16.0137 11.7571 15.404 9.62185 15.7933 8.08945C16.1814 6.56156 17.4241 6.2127 18.5621 7.3156C19.7035 8.42411 20.3086 10.5585 19.9205 12.0862Z",
    fill: "#384052"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.5058 11.831C19.3402 12.4912 18.9862 12.9009 18.5565 13.0244L17.2383 13.4059C17.6727 13.2797 18.022 12.8727 18.1924 12.2096C18.5311 10.8751 17.9979 9.01049 17.0071 8.04809C16.5065 7.56363 15.9813 7.39995 15.5469 7.52619L16.8603 7.14756C17.2986 7.02209 17.8201 7.18481 18.3206 7.66947C19.3151 8.63278 19.8456 10.4924 19.5058 11.831Z",
    fill: "#E3E6F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.5929 8.72444C14.2534 10.0578 14.7837 11.92 15.7757 12.8809C16.7726 13.8426 17.8552 13.5428 18.19 12.2082C18.5296 10.8748 17.9992 9.01263 17.0036 8.046C16.0115 7.08538 14.9335 7.38644 14.5929 8.72444Z",
    fill: "#B4BED7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.68591 17.6339C3.68591 17.6339 1.81501 15.7321 1.51996 15.0526C1.22495 14.3731 1.67946 13.9391 1.93655 12.9946C2.19364 12.0501 3.06397 12.075 3.06397 12.075L3.68591 17.6339Z",
    fill: "#E5B998"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.55664 17.9128C4.55664 17.9128 5.81376 21.0068 6.89179 20.7337C7.96982 20.4605 7.52304 19.3498 7.52304 19.3498C7.52304 19.3498 7.86029 20.855 8.67302 20.2391C9.48581 19.6232 8.81698 18.8206 8.81698 18.8206C8.81698 18.8206 10.3817 18.9692 9.05813 17.0335C7.73462 15.0978 4.55664 17.9128 4.55664 17.9128Z",
    fill: "#E5B998"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.5167 9.62231C6.94862 9.61064 6.65649 10.2268 6.58267 10.609C6.50885 10.9912 5.81563 9.51359 5.40374 9.31909C5.40374 9.31909 5.91974 10.2732 5.88989 10.9186C5.88989 10.9186 5.51549 11.5725 5.40029 11.162C5.28504 10.7515 4.99051 9.89092 4.86581 10.2122C4.7411 10.5334 4.98667 11.1868 4.99229 11.7508C4.9979 12.3148 4.2203 13.1916 3.89587 12.9765C3.57149 12.7613 3.06403 12.3888 2.72266 12.4877C2.72266 12.4877 3.42106 12.7422 3.64838 13.4727C3.87571 14.2032 4.31299 17.6746 4.15882 17.9481C4.00459 18.2217 4.97357 17.158 5.34974 16.7366C5.78294 16.2512 6.33897 16.1381 6.87321 15.7748C7.40741 15.4114 7.74691 14.6098 7.90209 14.1861C8.05728 13.7624 9.4715 12.2609 9.30701 11.3332C9.14246 10.4054 8.08483 9.63397 7.5167 9.62231Z",
    fill: "#E5B998"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M16.8539 8.22431C16.8366 8.20742 16.6617 8.06711 16.6444 8.05094C16.2256 7.66737 15.749 7.68215 15.2463 7.89681C14.655 8.14929 13.1098 8.23747 7.53371 6.83227C5.53226 6.32793 4.73819 6.25545 4.17338 7.19145C3.60856 8.12793 2.53369 9.73636 1.37109 11.1151C0.208382 12.4936 1.9863 14.2144 2.24982 14.9048C2.51329 15.595 2.80091 16.2464 2.64789 18.0054C2.49491 19.7639 3.88998 18.7318 3.88998 18.7318C3.8944 18.7629 3.89982 18.7939 3.90621 18.8237C4.0528 19.5155 4.76723 19.9329 5.45397 19.7647C6.65325 19.471 8.4665 18.4689 9.12448 17.5535C10.0188 16.3099 10.5464 16.3995 10.5464 16.3995C10.5464 16.3995 12.4647 16.6863 14.7138 15.5705C16.0492 14.9081 17.7274 12.8189 17.8649 12.4649C18.3592 11.1925 17.7798 9.12115 16.8539 8.22431ZM7.90182 14.186C7.74664 14.6098 7.40714 15.4114 6.87294 15.7744C6.33875 16.1379 5.78267 16.2511 5.34947 16.7366C4.97334 17.1578 4.00427 18.2217 4.15854 17.9481C4.31277 17.6743 4.13094 14.2031 3.90362 13.4727C3.67629 12.742 2.72238 12.4875 2.72238 12.4875C3.06376 12.3886 3.57122 12.761 3.8956 12.9765C4.22003 13.1914 4.99763 12.3145 4.99206 11.7506C4.9864 11.1865 4.74088 10.5334 4.86558 10.2121C4.99029 9.89082 5.28477 10.7513 5.40002 11.1619C5.51522 11.5721 5.88966 10.9186 5.88966 10.9186C5.91947 10.2732 5.40347 9.31881 5.40347 9.31881C5.81546 9.51345 6.50862 10.9911 6.58245 10.6089C6.65622 10.2266 6.9483 9.61065 7.51643 9.62202C8.08456 9.63364 9.14219 10.4053 9.30674 11.3331C9.47123 12.2607 8.05696 13.7623 7.90182 14.186Z",
    fill: "#F8D5B4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M2.32422 21.604L2.34697 22.7709C2.34755 22.8004 2.36559 22.8267 2.39291 22.8378C2.42017 22.849 2.45151 22.8429 2.47254 22.8222L3.30615 22.0055L2.32422 21.604Z",
    fill: "#282E3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M2.58688 19.2954L2.3104 21.5711C2.30128 21.6404 2.32653 21.7195 2.38917 21.8011C2.54407 22.0012 2.87536 22.1366 3.12602 22.1024C3.23171 22.0862 3.30746 22.0433 3.3472 21.9835L4.73738 20.1747L2.58688 19.2954Z",
    fill: "#384052"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M9.30538 9.02305L4.73741 20.1744C4.67223 20.3326 4.50346 20.4482 4.24608 20.4841C3.72802 20.5562 3.04699 20.2777 2.72511 19.8622C2.56311 19.653 2.52288 19.449 2.58893 19.2888L7.1569 8.13745C7.09085 8.29772 7.13107 8.50172 7.29307 8.71086C7.61496 9.1264 8.29599 9.40484 8.814 9.3327C9.07143 9.29689 9.24019 9.18126 9.30538 9.02305Z",
    fill: "#4D5772"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M6.64392 14.632C6.12484 14.7032 5.44512 14.4252 5.12169 14.0097C4.96056 13.8004 4.91908 13.6001 4.98446 13.4402L4.79184 13.9114C4.72646 14.0713 4.76563 14.2773 4.92787 14.4838C5.25014 14.9022 5.92987 15.1801 6.45009 15.1062C6.70478 15.0702 6.87465 14.9564 6.94003 14.7964L7.13385 14.3223C7.06848 14.4822 6.89856 14.5962 6.64392 14.632Z",
    fill: "#ED5E72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9.3139 8.11357C8.79367 8.18749 8.11399 7.90957 7.79167 7.49115C7.63049 7.28207 7.59022 7.07888 7.65559 6.91895L7.46186 7.39295C7.39639 7.55303 7.43551 7.75899 7.59665 7.96823C7.92012 8.38371 8.59985 8.66159 9.11887 8.59064C9.37471 8.55186 9.54343 8.44078 9.60881 8.28085L9.80378 7.80392C9.73841 7.96391 9.56854 8.07771 9.3139 8.11357Z",
    fill: "#86AEDC"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M9.1696 8.44992C8.84766 8.03429 8.16678 7.75589 7.64867 7.82803C7.1306 7.90017 6.97148 8.29545 7.29347 8.71109C7.61536 9.12662 8.29638 9.40507 8.8144 9.33293C9.33256 9.26083 9.49153 8.86545 9.1696 8.44992Z",
    fill: "#F8D4B4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M11.5987 3.59938L9.2105 9.42447C9.14138 9.59223 8.96244 9.71477 8.68956 9.75274C8.14029 9.8292 7.41823 9.534 7.0769 9.09341C6.90516 8.8717 6.86253 8.65541 6.93256 8.48549L9.32071 2.6604C9.25072 2.83032 9.29335 3.04661 9.46509 3.26837C9.80637 3.70891 10.5284 4.00416 11.0777 3.9277C11.3506 3.88968 11.5295 3.76714 11.5987 3.59938Z",
    fill: "#ED5E72"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M11.4548 2.99147C11.1135 2.55078 10.3916 2.25563 9.84221 2.33214C9.29295 2.40856 9.12423 2.82769 9.4656 3.26838C9.80688 3.70892 10.5289 4.00417 11.0782 3.92771C11.6276 3.85124 11.7961 3.43201 11.4548 2.99147Z",
    fill: "#F491AB"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M11.7548 1.93357L11.1765 3.338C11.1345 3.43991 11.0258 3.51435 10.8601 3.53739C10.5265 3.58386 10.0879 3.40453 9.88066 3.13698C9.77636 3.00229 9.75044 2.87096 9.79297 2.76776L10.3713 1.36328C10.3288 1.46648 10.3547 1.59786 10.459 1.73255C10.6662 2.0001 11.1048 2.17943 11.4384 2.13296C11.6042 2.10987 11.7128 2.03547 11.7548 1.93357Z",
    fill: "#384052"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M11.6669 1.56428C11.4596 1.29663 11.0211 1.1174 10.6875 1.16381C10.3539 1.21028 10.2515 1.46482 10.4588 1.73247C10.6661 2.00002 11.1046 2.17935 11.4382 2.13288C11.7719 2.08647 11.8742 1.83183 11.6669 1.56428Z",
    fill: "#4D5772"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M11.7211 5.06171C11.7303 5.11177 11.7244 5.16942 11.7078 5.20988L10.0927 9.13215C10.0736 9.17852 10.0452 9.20219 10.0165 9.20243L9.58008 9.26372C9.6036 9.25815 9.62827 9.23535 9.64579 9.19331L11.2609 5.27108C11.2775 5.23052 11.2823 5.17326 11.2742 5.12286C11.2703 5.0728 11.2493 5.02283 11.2242 4.98304L10.7648 4.39369L11.2119 4.33374L11.6686 4.92769C11.6962 4.96172 11.7129 5.01001 11.7211 5.06171Z",
    fill: "#E44555"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M11.2249 4.98584C11.282 5.05956 11.2974 5.18835 11.2622 5.27403L9.64577 9.19616C9.61039 9.28198 9.53796 9.29148 9.48084 9.21771C9.42372 9.14398 9.40423 9.01582 9.43961 8.93L10.9913 5.16478L10.6378 4.70768L10.7671 4.39404L11.2249 4.98584Z",
    fill: "#F491AB"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M5.34961 16.7366C4.97343 17.1581 4.00446 18.2217 4.15868 17.9482C4.28958 17.716 4.24978 15.1801 4.01847 13.9719L1.95898 14.3982C2.09103 14.5989 2.19898 14.7713 2.24991 14.9049C2.51338 15.5952 2.80105 16.2464 2.64807 18.0053C2.49505 19.7641 3.89012 18.732 3.89012 18.732C3.89454 18.7631 3.89996 18.7937 3.90634 18.8238C4.05294 19.5154 4.76742 19.933 5.4541 19.7649C6.21817 19.5778 7.23106 19.1029 8.03602 18.5463L7.28574 15.371C7.16396 15.5287 7.02687 15.6703 6.87308 15.7748C6.33884 16.1381 5.78281 16.2512 5.34961 16.7366Z",
    fill: "#F8D5B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M3.89062 18.732C3.89859 18.5994 3.92672 18.4698 3.96502 18.3432C3.98504 18.2801 4.0077 18.2175 4.03717 18.1578C4.06635 18.0983 4.09914 18.0384 4.14733 17.9917C4.11646 18.0504 4.09429 18.1112 4.07298 18.1726C4.05258 18.2342 4.0317 18.2957 4.01307 18.3582C3.97342 18.4824 3.93694 18.6077 3.89062 18.732Z",
    fill: "#E5B998"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M5.45166 17.1128L4.59256 17.7913C4.59256 17.7913 3.6183 18.4856 4.0251 19.1533C4.44002 19.8344 4.89832 19.9533 5.62552 19.6705C6.35272 19.3877 6.92469 19.0336 6.92469 19.0336C6.92469 19.0336 5.60104 17.9455 5.45166 17.1128Z",
    fill: "#E3E6F0"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1653_4471"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutograph);
export default __webpack_public_path__ + "static/media/autograph.639b4a4349b1bd3d36e2bc56bcb2d9e0.svg";
export { ForwardRef as ReactComponent };